import React from "react";
import { Layers } from "lucide-react";
import ShortcutButton from "../molecules/ShortcutButton";
import BureauCard from "../atoms/BureauCard";
import { INK, BURGUNDY } from "../bureauTokens";

function ShortcutsPanel({ shortcuts }) {
  return (
    <BureauCard>
      <div className="flex items-center gap-2 text-xs font-semibold mb-3" style={{ color: INK }}>
        <Layers size={14} style={{ color: BURGUNDY }} /> Raccourcis
      </div>
      <div className="grid grid-cols-2 gap-2">
        {shortcuts.map((s) => (
          <ShortcutButton
            key={s.key}
            icon={s.icon}
            label={s.label}
            badge={s.badge}
            disabled={s.disabled}
            onClick={s.onClick}
          />
        ))}
      </div>
    </BureauCard>
  );
}

export default ShortcutsPanel;
